import React, { FC } from 'react'

import { ArrowRightIcon, IconSizes } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FullTourStepSeven.module.scss'
import { UserManagementRole } from './FullTourStepSeven.types'

export const FullTourStepSeven: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_seven'
  })
  const pathChips = t('path_chips', { returnObjects: true }) as string[]
  const roles = t('roles', { returnObjects: true }) as UserManagementRole[]

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-seven-title'
      aria-describedby='full-tour-step-seven-description'
    >
      <div className={styles.tourMain}>
        <div className={styles.tourLeft}>
          <div className={styles.tourHeading}>
            <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
            <h1 id='full-tour-step-seven-title' className={styles.tourTitle}>
              <span>{t('title_before')}</span>
              <span className={styles.titleHighlight}>
                {t('title_highlighted')}
              </span>
            </h1>
          </div>

          <div className={styles.tourDetails}>
            <nav className={styles.path} aria-label={t('path_label')}>
              {pathChips.map((chip, index) => (
                <React.Fragment key={chip}>
                  {index > 0 && (
                    <ArrowRightIcon
                      aria-hidden='true'
                      color='var(--white)'
                      size={IconSizes.Size16}
                    />
                  )}
                  <span className={styles.pathChip}>{chip}</span>
                </React.Fragment>
              ))}
            </nav>

            <p
              id='full-tour-step-seven-description'
              className={styles.tourDescription}
            >
              {t('description_before')}
              <strong>{t('description_highlighted')}</strong>
              {t('description_after')}
            </p>
          </div>
        </div>

        <div className={styles.roles}>
          {roles.map(role => (
            <div key={role.label} className={styles.roleCard}>
              <span className={styles.roleChip}>{role.label}</span>
              <p>{role.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
